import gql from 'graphql-tag';

export default class HeroSectionQueries {
  static findCompanies = gql`
    query FindCompanies($keyword: String!) {
      findCompanies(keyword: $keyword) {
        logo
        name
        domain
      }
    }
  `;
}
